import PropTypes, { number } from "prop-types";
import { propTypes } from "react-bootstrap/esm/Image";

export const cardPricesType = PropTypes.objectOf(
  PropTypes.shape({
    price: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
  })
);

export const cardInitType = PropTypes.shape({ loading: PropTypes.bool.isRequired });

export const cardBasicType = PropTypes.shape({
  cards: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired, url: PropTypes.string.isRequired })),
  inclusion: PropTypes.number,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  names: PropTypes.arrayOf(PropTypes.string),
  num_decks: PropTypes.number,
  potential_decks: PropTypes.number,
  sanitized: PropTypes.string,
  sanitized_wo: PropTypes.string,
  url: PropTypes.string,
});

export const cardRichType = PropTypes.shape({
  aetherhub_uri: PropTypes.string,
  archidekt_uri: PropTypes.string,
  banned: PropTypes.bool,
  cardmarket_id: PropTypes.number,
  cmc: PropTypes.number,
  color_identity: PropTypes.arrayOf(PropTypes.string),
  deckstats_uri: PropTypes.string,
  id: PropTypes.string.isRequired,
  image_uri: PropTypes.string.isRequired,
  image_uris: PropTypes.arrayOf(PropTypes.string).isRequired,
  layout: PropTypes.string.isRequired,
  legal_commander: PropTypes.bool.isRequired,
  legal_companion: PropTypes.bool.isRequired,
  legal_partner: PropTypes.bool.isRequired,
  mana_cost: PropTypes.string,
  moxfield_uri: PropTypes.string.isRequired,
  mtggoldfish_uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  names: PropTypes.arrayOf(PropTypes.string).isRequired,
  new: PropTypes.bool.isRequired,
  oracle_text: PropTypes.string,
  power: PropTypes.string,
  precon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  prices: cardPricesType,
  primary_type: PropTypes.string.isRequired,
  rarity: PropTypes.string.isRequired,
  released_at: PropTypes.string.isRequired,
  salt: PropTypes.number.isRequired,
  scryfall_uri: PropTypes.string.isRequired,
  sets: PropTypes.arrayOf(PropTypes.string).isRequired,
  toughness: PropTypes.string,
  type: PropTypes.string.isRequired,
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  unique_artwork: PropTypes.arrayOf(
    PropTypes.shape({
      artist: PropTypes.string.isRequired,
      collector_number: PropTypes.string.isRequired,
      image_uris: PropTypes.arrayOf(PropTypes.string).isRequired,
      set: PropTypes.string.isRequired,
      set_name: PropTypes.string.isRequired,
    })
  ).isRequired,
  unofficial: PropTypes.bool.isRequired,
  url: PropTypes.string,
});

export const cardListType = PropTypes.shape({
  cardviews: PropTypes.arrayOf(cardBasicType),
  header: PropTypes.string.isRequired,
  more: PropTypes.string,
  tag: PropTypes.string,
});

export const filterType = PropTypes.shape({
  key: PropTypes.string,
  type: PropTypes.string,
  values: PropTypes.any,
});

export const videoType = PropTypes.shape({
  author: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    id: number.isRequired,
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  cards: PropTypes.arrayOf(PropTypes.string),
  categories: PropTypes.arrayOf(
    PropTypes.shape({ id: number.isRequired, link: PropTypes.string.isRequired, name: PropTypes.string.isRequired })
  ),
  date: PropTypes.string.isRequired,
  date_gmt: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  modified_gmt: PropTypes.string.isRequired,
  site: PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string.isRequired }),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      link: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  title: PropTypes.string.isRequired,
  youtube: PropTypes.string.isRequired,
});

export const articleType = PropTypes.shape({
  alt: PropTypes.string.isRequired,
  author: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  date: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  site: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  value: PropTypes.string.isRequired,
});
